import { createBrowserRouter } from "react-router-dom";
import { RootLayout } from "./layouts/RootLayout";
import { AdminLayout } from "./layouts/AdminLayout";
import { ProtectedRoute } from "./ProtectedRoute";
import { DefaultRedirect } from "./DefaultRedirect";

import LoginPage from "@/pages/LoginPage";
import CallbackPage from "@/pages/CallbackPage";
import UnauthorizedPage from "@/pages/UnauthorizedPage";
import SubscriptionsPage from "@/pages/SubscriptionsPage";
import ArticlesPage from "@/pages/ArticlesPage";
import ArticleNewPage from "@/pages/ArticleNewPage";
import ArticleEditPage from "@/pages/ArticleEditPage";
import ArticlePublishPage from "@/pages/ArticlePublishPage";
import ArticleFilesPage from "@/pages/ArticleFilesPage";
import ChangelogPage from "@/pages/ChangelogPage";
import ChangelogNewPage from "@/pages/ChangelogNewPage";
import ChangelogEditPage from "@/pages/ChangelogEditPage";
import HandbookPage from "@/pages/HandbookPage";
import HandbookNewPage from "@/pages/HandbookNewPage";
import HandbookEditPage from "@/pages/HandbookEditPage";
import StructurePage from "@/pages/StructurePage";
import ExperimentsPage from "@/pages/ExperimentsPage";
import SurveyPage from "@/pages/SurveyPage";
import ChatFeedbacksPage from "@/pages/ChatFeedbacksPage";
import AnalysisPage from "@/pages/AnalysisPage";
import ContestSubmissionsPage from "@/pages/ContestSubmissionsPage";
import ContestSubmissionDetailPage from "@/pages/ContestSubmissionDetailPage";
import UserDataExportPage from "@/pages/UserDataExportPage";
import UserDataViewerPage from "@/pages/UserDataViewerPage";
import FileHistoryViewerPage from "@/pages/FileHistoryViewerPage";
import UserConversationsPage from "@/pages/UserConversationsPage";
import AccountDeletionSurveyPage from "@/pages/AccountDeletionSurveyPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { path: "login", element: <LoginPage /> },
      { path: "callback/google", element: <CallbackPage /> },
      { path: "unauthorized", element: <UnauthorizedPage /> },

      {
        element: <ProtectedRoute />,
        children: [
          {
            element: <AdminLayout />,
            children: [
              {
                index: true,
                element: <DefaultRedirect />,
              },
              { path: "subscriptions", element: <SubscriptionsPage /> },
              { path: "articles", element: <ArticlesPage /> },
              { path: "articles/files", element: <ArticleFilesPage /> },
              { path: "articles/new", element: <ArticleNewPage /> },
              {
                path: "articles/:articleId/edit",
                element: <ArticleEditPage />,
              },
              {
                path: "articles/publish/:fileId",
                element: <ArticlePublishPage />,
              },
              { path: "changelog", element: <ChangelogPage /> },
              { path: "changelog/new", element: <ChangelogNewPage /> },
              {
                path: "changelog/:entryId/edit",
                element: <ChangelogEditPage />,
              },
              { path: "handbook", element: <HandbookPage /> },
              { path: "handbook/new", element: <HandbookNewPage /> },
              {
                path: "handbook/:handbookId/edit",
                element: <HandbookEditPage />,
              },
              { path: "structure", element: <StructurePage /> },
              { path: "experiments", element: <ExperimentsPage /> },
              { path: "survey", element: <SurveyPage /> },
              { path: "chat-feedbacks", element: <ChatFeedbacksPage /> },
              { path: "analysis", element: <AnalysisPage /> },
              {
                path: "contest-submissions",
                element: <ContestSubmissionsPage />,
              },
              {
                path: "contest-submissions/:submissionId",
                element: <ContestSubmissionDetailPage />,
              },
              { path: "user-data-export", element: <UserDataExportPage /> },
              { path: "user-data-viewer", element: <UserDataViewerPage /> },
              {
                path: "file-history-viewer",
                element: <FileHistoryViewerPage />,
              },
              {
                path: "user-conversations",
                element: <UserConversationsPage />,
              },
              {
                path: "account-deletion-survey",
                element: <AccountDeletionSurveyPage />,
              },
            ],
          },
        ],
      },
    ],
  },
]);
